/**
 * Marriage & Family Law hub — register with the global subcategory registry.
 */
import { MARRIAGE_FAMILY_LAW_SLUG, marriageFamilyLawDefaultData } from "./marriageFamilyLawData";
import { MarriageFamilyArticlesTab, MarriageFamilyMediaTab, MarriageFamilyOverviewTab } from "./MarriageFamilyLawDesign";

export const marriageFamilyLawModule = {
  slug: MARRIAGE_FAMILY_LAW_SLUG,
  getDefaultData: () => marriageFamilyLawDefaultData,
  Views: {
    overview: MarriageFamilyOverviewTab,
    articles: MarriageFamilyArticlesTab,
    media: MarriageFamilyMediaTab,
  },
};
